var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showWordspotting && _vm.loaded)?_c('div',[_c('h1',{attrs:{"id":"wordspottingheader"}},[_vm._v("\n    Manage Wordspotting\n  ")]),_vm._v(" "),_c('manage-wordspotting')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }